import { render } from "./PictureNews.vue?vue&type=template&id=f7b7f93a"
import script from "./PictureNews.vue?vue&type=script&lang=js"
export * from "./PictureNews.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__